(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-home-atelier"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cb-home-slideshow')) {
  customElements.define('cb-home-slideshow',class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      this.photos=Array.from(this.querySelectorAll('img'));
      if(this.photos.length<2)return;
      this.index=0;this.paused=false;this.visible=false;this.hovered=false;
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.photos[0].classList.add('is-active');this.setAttribute('data-ready','');
      this.control=this.querySelector('button');this.control.hidden=false;
      this.toggle=()=>{this.paused=!this.paused;this.control.setAttribute('aria-pressed',String(this.paused));this.control.textContent=this.paused?this.dataset.playLabel:this.dataset.pauseLabel;this.sync();};
      this.control.addEventListener('click',this.toggle);
      this.enter=()=>{this.hovered=true;this.sync();};this.leave=()=>{this.hovered=false;this.sync();};
      this.addEventListener('mouseenter',this.enter);this.addEventListener('mouseleave',this.leave);
      this.focus=()=>{this.focused=true;this.sync();};this.blur=e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.sync();}};
      this.addEventListener('focusin',this.focus);this.addEventListener('focusout',this.blur);
      this.visibility=()=>this.sync();document.addEventListener('visibilitychange',this.visibility);
      this.motion.addEventListener('change',this.visibility);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.15});this.observer.observe(this);
    }
    sync(){clearInterval(this.timer);if(this.visible&&!this.paused&&!this.hovered&&!this.focused&&!this.motion.matches&&!document.hidden)this.timer=setInterval(()=>this.next(),3800);}
    next(){const next=(this.index+1)%this.photos.length;const photo=this.photos[next];if(!photo.complete||!photo.naturalWidth)return;this.photos[this.index].classList.remove('is-active');this.photos[this.index].setAttribute('aria-hidden','true');photo.classList.add('is-active');photo.removeAttribute('aria-hidden');this.index=next;}
    disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.control?.removeEventListener('click',this.toggle);this.removeEventListener('mouseenter',this.enter);this.removeEventListener('mouseleave',this.leave);this.removeEventListener('focusin',this.focus);this.removeEventListener('focusout',this.blur);document.removeEventListener('visibilitychange',this.visibility);this.motion?.removeEventListener('change',this.visibility);this.initialized=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
